// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es7.weak-map.of.js
// module id = 1389
// module chunks = 168707334958949